/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Request for create or update a common financial group
 * @export
 * @interface CreateUpdateCommonFinancialGroupRequest
 */
export interface CreateUpdateCommonFinancialGroupRequest {
    /**
     * The financial group code
     * @type {string}
     * @memberof CreateUpdateCommonFinancialGroupRequest
     */
    code?: string;
    /**
     * The financial group name
     * @type {string}
     * @memberof CreateUpdateCommonFinancialGroupRequest
     */
    title?: string;
    /**
     * The misa number of a common financial group
     * @type {string}
     * @memberof CreateUpdateCommonFinancialGroupRequest
     */
    misaNumber?: string;
    /**
     * The personal info appearing on the bill
     * @type {string}
     * @memberof CreateUpdateCommonFinancialGroupRequest
     */
    personalInfo?: string;
    /**
     * the active status of the common financial group
     * @type {boolean}
     * @memberof CreateUpdateCommonFinancialGroupRequest
     */
    active?: boolean;
}

/**
 * Check if a given object implements the CreateUpdateCommonFinancialGroupRequest interface.
 */
export function instanceOfCreateUpdateCommonFinancialGroupRequest(value: object): value is CreateUpdateCommonFinancialGroupRequest {
    return true;
}

export function CreateUpdateCommonFinancialGroupRequestFromJSON(json: any): CreateUpdateCommonFinancialGroupRequest {
    return CreateUpdateCommonFinancialGroupRequestFromJSONTyped(json, false);
}

export function CreateUpdateCommonFinancialGroupRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateUpdateCommonFinancialGroupRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'title': json['title'] == null ? undefined : json['title'],
        'misaNumber': json['misaNumber'] == null ? undefined : json['misaNumber'],
        'personalInfo': json['personalInfo'] == null ? undefined : json['personalInfo'],
        'active': json['active'] == null ? undefined : json['active'],
    };
}

export function CreateUpdateCommonFinancialGroupRequestToJSON(json: any): CreateUpdateCommonFinancialGroupRequest {
    return CreateUpdateCommonFinancialGroupRequestToJSONTyped(json, false);
}

export function CreateUpdateCommonFinancialGroupRequestToJSONTyped(value?: CreateUpdateCommonFinancialGroupRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'title': value['title'],
        'misaNumber': value['misaNumber'],
        'personalInfo': value['personalInfo'],
        'active': value['active'],
    };
}

